import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\AddWikiItemsToInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/AddWikiItemsToInvoiceController.php
* @route '/api/invoice/{invoice}/add-wiki-items'
*/
const AddWikiItemsToInvoiceController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddWikiItemsToInvoiceController.url(args, options),
    method: 'post',
})

AddWikiItemsToInvoiceController.definition = {
    methods: ["post"],
    url: '/api/invoice/{invoice}/add-wiki-items',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\AddWikiItemsToInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/AddWikiItemsToInvoiceController.php
* @route '/api/invoice/{invoice}/add-wiki-items'
*/
AddWikiItemsToInvoiceController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return AddWikiItemsToInvoiceController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\AddWikiItemsToInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/AddWikiItemsToInvoiceController.php
* @route '/api/invoice/{invoice}/add-wiki-items'
*/
AddWikiItemsToInvoiceController.post = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddWikiItemsToInvoiceController.url(args, options),
    method: 'post',
})

export default AddWikiItemsToInvoiceController